import type { LauncherButtonConfig } from "@deskpro-product/messenger-api-schemas/messenger-init/types";
import type { MessengerConfig } from "@deskpro-product/messenger-api-schemas/messenger/config";
import type { MessengerThemeSettings } from "@deskpro-product/messenger-api-schemas/messenger/config/settings";
import deepmerge from "deepmerge";

/**
 * MessengerApp config is passed via postMessage from the host page.
 */
export default function mergeConfigWithOverrides(
  config: MessengerConfig,
  messengerAppConfig?: MessengerThemeSettings,
  launcherButtonConfig?: LauncherButtonConfig,
): MessengerConfig {
  return {
    ...config,
    settings: {
      ...config.settings,
      themeSettings: messengerAppConfig
        ? deepmerge(config.settings?.themeSettings ?? {}, messengerAppConfig)
        : config.settings?.themeSettings,
      launcherSettings: {
        ...config.settings?.launcherSettings,
      },
      displaySettings: {
        ...config.settings?.displaySettings,
        placement: {
          offsetBottom:
            launcherButtonConfig?.placement?.offsetBottom ||
            config.settings?.displaySettings.placement?.offsetBottom,
          offsetSide:
            launcherButtonConfig?.placement?.offsetSide ||
            config.settings?.displaySettings.placement?.offsetSide,
          position:
            launcherButtonConfig?.placement?.position ||
            config.settings?.displaySettings.placement?.position,
        },
      },
    },
  };
}
